
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3mVfX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
var $4440a0699c7a4c4d$export$6a393d893fab1730 = /*#__PURE__*/ function(SidebarTabValues) {
    SidebarTabValues["COMMENTS"] = "COMMENTS";
    SidebarTabValues["SUGGESTIONS"] = "SUGGESTIONS";
    return SidebarTabValues;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        currentSidebarTab: "COMMENTS",
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setCurrentSidebarTab: (tab)=>({ setState: setState })=>{
            setState({
                currentSidebarTab: tab
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $8s9DV.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $kBr4q.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $kBr4q.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $kBr4q.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["SidebarTabValues"] = $4440a0699c7a4c4d$export$6a393d893fab1730;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("5fMeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $jmjWc = parcelRequire("jmjWc");


var $kDhla = parcelRequire("kDhla");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("bXbI9"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("cgPHt"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("60ddt"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("gzO1J"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uSRQM",
    name: "CommentsPanelFooterWrapper",
    loader: async ()=>(await (parcelRequire("h5xfH"))).CommentsPanelFooterWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("5mNmP"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    },
    discussionsPanelHeaderLabel: {
        id: "comments-panel.panel.header.discussions.label",
        defaultMessage: "Discussions"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { currentSidebarTab: currentSidebarTab } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, setCurrentSidebarTab: setCurrentSidebarTab } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $cozmU.useRef)(hasContentChanged);
    (0, $cozmU.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    (0, $cozmU.useEffect)(()=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.setUIVisibility(isObjectSidebarShown);
    }, [
        isObjectSidebarShown,
        fullPageEditorPresetAPI
    ]);
    // Track whether the Suggestions tab was visited during this sidebar session,
    // so we can keep the suggestion node selected in the editor after close
    // (regardless of which tab is active when the panel is dismissed).
    const hadSuggestionsTabRef = (0, $cozmU.useRef)(false);
    // Track the previous value of currentSidebarTab so we can detect when the
    // user actively switches *away from* the Suggestions tab (as opposed to
    // the tab simply being COMMENTS when the sidebar first opens).
    const prevSidebarTabRef = (0, $cozmU.useRef)(currentSidebarTab);
    // When the sidebar finishes closing, reset the session flag and the tab
    // back to COMMENTS so subsequent non-suggestion opens start clean.
    (0, $cozmU.useEffect)(()=>{
        if (!isObjectSidebarShown) {
            hadSuggestionsTabRef.current = false;
            setCurrentSidebarTab?.((0, $3mVfX.SidebarTabValues).COMMENTS);
        }
    }, [
        isObjectSidebarShown,
        setCurrentSidebarTab
    ]);
    (0, $cozmU.useEffect)(()=>{
        const prevTab = prevSidebarTabRef.current;
        if (currentSidebarTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS) hadSuggestionsTabRef.current = true;
        // Only deselect the suggestion when the user actively switches away
        // from the Suggestions tab (prev was SUGGESTIONS, now it is not).
        // This avoids deselecting on initial sidebar open (where prev and
        // current are both COMMENTS) and on sidebar close.
        if (prevTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS && currentSidebarTab !== (0, $3mVfX.SidebarTabValues).SUGGESTIONS && isObjectSidebarShown) fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(null, {
            interactionPoint: 'sidebar'
        });
        // Update prev ref *after* checking it
        prevSidebarTabRef.current = currentSidebarTab;
    }, [
        currentSidebarTab,
        fullPageEditorPresetAPI,
        isObjectSidebarShown
    ]);
    const onPanelCloseFunction = ()=>{
        const closingFromSuggestions = hadSuggestionsTabRef.current;
        setCurrentView(undefined);
        // When closing from a suggestions session, skip resetting the tab to
        // COMMENTS so the useEffect that watches currentSidebarTab does not
        // fire selectSuggestion(null) during the close transition.
        if (!closingFromSuggestions) {
            setCurrentSidebarTab((0, $3mVfX.SidebarTabValues).COMMENTS);
            // Unselect active annotations on the page
            if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            } else {
                eventEmitter.emit('setselectedannotation', '');
                setEditorViewProps(null);
            }
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $cozmU.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        setCurrentSidebarTab
    ]);
    const canClosePanel = (0, $cozmU.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, openWithTab: openWithTab, suggestionsRightRailEntryPoint: suggestionsRightRailEntryPoint } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                openWithView: openWithView,
                ...isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && {
                    openWithTab: openWithTab
                },
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        /**
     * Logic for showing the footer for platform_editor_ai_content_suggested_edits
     * There is additional logic for comments vs. suggestions inside CommentsPanelFooterWrapper
     */ const showFooterCommon = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        const showDiscussionLabel = !isDatabaseView && !isWhiteboardView && !isSlidesView;
        // When the gate is on, use CommentsPanelFooterWrapper which reactively
        // switches between SuggestionsFooter and CommentsPanelFooter based on
        // the current tab — without needing to re-open the sidebar.
        // When the gate is off, fall back to the original CommentsPanelFooter.
        const FooterComponent = showFooterCommon ? $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper : undefined;
        const OldFooterComponent = showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: showDiscussionLabel && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$export$a7357cdd1f0b0168.discussionsPanelHeaderLabel : $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView,
                    openWithTab: openWithTab,
                    suggestionsRightRailEntryPoint: suggestionsRightRailEntryPoint
                }),
            FooterComponent: isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? FooterComponent : OldFooterComponent,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $cozmU.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isRovoLLMEnabled,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("bXbI9", function(module, exports) {

let $8b3e49f88ba39737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8b3e49f88ba39737$var$load("iMohY"),
    $8b3e49f88ba39737$var$load("3SirY"),
    $8b3e49f88ba39737$var$load("w3Gc8"),
    $8b3e49f88ba39737$var$load("hs6P3"),
    $8b3e49f88ba39737$var$load("lgIhe"),
    $8b3e49f88ba39737$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("cgPHt", function(module, exports) {

let $8eef153877f33e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8eef153877f33e75$var$load("fblhQ"),
    $8eef153877f33e75$var$load("ia7Cd"),
    $8eef153877f33e75$var$load("60QcS"),
    $8eef153877f33e75$var$load("iMohY"),
    $8eef153877f33e75$var$load("3SirY"),
    $8eef153877f33e75$var$load("6wr18"),
    $8eef153877f33e75$var$load("aIw3f"),
    $8eef153877f33e75$var$load("8LtYa"),
    $8eef153877f33e75$var$load("ffEVr"),
    $8eef153877f33e75$var$load("4XoWv"),
    $8eef153877f33e75$var$load("4W6oq"),
    $8eef153877f33e75$var$load("hs6P3"),
    $8eef153877f33e75$var$load("4nSVX"),
    $8eef153877f33e75$var$load("kaJZa"),
    $8eef153877f33e75$var$load("2PbSP"),
    $8eef153877f33e75$var$load("aAWLw"),
    $8eef153877f33e75$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("60ddt", function(module, exports) {

let $45ecfea625e292e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45ecfea625e292e8$var$load("6wr18"),
    $45ecfea625e292e8$var$load("ffEVr"),
    $45ecfea625e292e8$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("gzO1J", function(module, exports) {

let $c116b88255baa502$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c116b88255baa502$var$load("18viy"),
    $c116b88255baa502$var$load("adeQI"),
    $c116b88255baa502$var$load("ccAQf"),
    $c116b88255baa502$var$load("ipIDQ"),
    $c116b88255baa502$var$load("el56J"),
    $c116b88255baa502$var$load("fblhQ"),
    $c116b88255baa502$var$load("ia7Cd"),
    $c116b88255baa502$var$load("f3wA3"),
    $c116b88255baa502$var$load("7q3P3"),
    $c116b88255baa502$var$load("dfVz8"),
    $c116b88255baa502$var$load("cJsay"),
    $c116b88255baa502$var$load("kMS6I"),
    $c116b88255baa502$var$load("jsNWB"),
    $c116b88255baa502$var$load("1GCFv"),
    $c116b88255baa502$var$load("byAMe"),
    $c116b88255baa502$var$load("fHwKU"),
    $c116b88255baa502$var$load("b0ARW"),
    $c116b88255baa502$var$load("e5ukl"),
    $c116b88255baa502$var$load("bGvBs"),
    $c116b88255baa502$var$load("7YvWq"),
    $c116b88255baa502$var$load("52ZTT"),
    $c116b88255baa502$var$load("8vGrd"),
    $c116b88255baa502$var$load("blCE0"),
    $c116b88255baa502$var$load("cmmpX"),
    $c116b88255baa502$var$load("4XoWv"),
    $c116b88255baa502$var$load("hs6P3"),
    $c116b88255baa502$var$load("jqoep"),
    $c116b88255baa502$var$load("eUsnQ"),
    $c116b88255baa502$var$load("ariuh"),
    $c116b88255baa502$var$load("cFgVe"),
    $c116b88255baa502$var$load("5wzAc"),
    $c116b88255baa502$var$load("7EorR"),
    $c116b88255baa502$var$load("aLwQm"),
    $c116b88255baa502$var$load("6wr18"),
    $c116b88255baa502$var$load("Wowvf"),
    $c116b88255baa502$var$load("7gL7H"),
    $c116b88255baa502$var$load("hhss7"),
    $c116b88255baa502$var$load("5Y9Ri"),
    $c116b88255baa502$var$load("76WRh"),
    $c116b88255baa502$var$load("1oKjW"),
    $c116b88255baa502$var$load("4nSVX"),
    $c116b88255baa502$var$load("kaJZa"),
    $c116b88255baa502$var$load("ffEVr"),
    $c116b88255baa502$var$load("gpF3C"),
    $c116b88255baa502$var$load("dEUQZ"),
    $c116b88255baa502$var$load("h7ECu"),
    $c116b88255baa502$var$load("80Yra"),
    $c116b88255baa502$var$load("2PbSP"),
    $c116b88255baa502$var$load("feGHs"),
    $c116b88255baa502$var$load("60QcS"),
    $c116b88255baa502$var$load("35Mi3"),
    $c116b88255baa502$var$load("iMohY"),
    $c116b88255baa502$var$load("3SirY"),
    $c116b88255baa502$var$load("U5a3d"),
    $c116b88255baa502$var$load("1QIUS"),
    $c116b88255baa502$var$load("79Tk4"),
    $c116b88255baa502$var$load("jd0S2"),
    $c116b88255baa502$var$load("dpmaH"),
    $c116b88255baa502$var$load("aAWLw"),
    $c116b88255baa502$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("h5xfH", function(module, exports) {

let $c70cb28161a8f07c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c70cb28161a8f07c$var$load("fblhQ"),
    $c70cb28161a8f07c$var$load("ia7Cd"),
    $c70cb28161a8f07c$var$load("60QcS"),
    $c70cb28161a8f07c$var$load("iMohY"),
    $c70cb28161a8f07c$var$load("3SirY"),
    $c70cb28161a8f07c$var$load("6wr18"),
    $c70cb28161a8f07c$var$load("aIw3f"),
    $c70cb28161a8f07c$var$load("8LtYa"),
    $c70cb28161a8f07c$var$load("ffEVr"),
    $c70cb28161a8f07c$var$load("4XoWv"),
    $c70cb28161a8f07c$var$load("4W6oq"),
    $c70cb28161a8f07c$var$load("hs6P3"),
    $c70cb28161a8f07c$var$load("4nSVX"),
    $c70cb28161a8f07c$var$load("kaJZa"),
    $c70cb28161a8f07c$var$load("2PbSP"),
    $c70cb28161a8f07c$var$load("6q8Rl"),
    $c70cb28161a8f07c$var$load("aAWLw"),
    $c70cb28161a8f07c$var$load("ioZhb")
]).then(()=>parcelRequire('eBrKE'));

});

parcelRegister("5mNmP", function(module, exports) {

let $3e854d1d946b5b95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3e854d1d946b5b95$var$load("iMohY"),
    $3e854d1d946b5b95$var$load("3SirY"),
    $3e854d1d946b5b95$var$load("w3Gc8"),
    $3e854d1d946b5b95$var$load("hs6P3"),
    $3e854d1d946b5b95$var$load("lgIhe"),
    $3e854d1d946b5b95$var$load("bZz7X"),
    $3e854d1d946b5b95$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});


//# sourceMappingURL=QuickReload.4698355f.js.map
